export enum Roles {
    regular = "Regular",
    super = "Super",
    admin = "Admin",
};